import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AuthService } from '../_services/auth.service';
import { UserSessionDataForm } from '../_models/login/user-session-data-form';

@Component({
  selector: 'app-success-dialog',
  templateUrl: './success-dialog.component.html',
  styleUrls: ['./success-dialog.component.css']
})
export class SuccessDialogComponent implements OnInit {
  learningTitle: string;
  routerLink: string;

  userDataSession;
  userDisplayName = '';
  urlLink = '';

  constructor(public dialogRef: MatDialogRef<SuccessDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthService,
  ) {
    this.learningTitle = data.title;
    this.routerLink = data.routerLink;
  }

  ngOnInit() {

    this.authService.checkUserSession();
    const currentUser = localStorage.getItem('currentUser');
    const currentUserJson: UserSessionDataForm = JSON.parse(currentUser);
    this.userDataSession = currentUserJson;
    if (currentUserJson != null) {
      if (this.userDataSession.firstName) {
        this.userDisplayName = this.userDataSession.firstName;
      }
    }
  }
}
